export const languageTranslations = {
  Abchasisch: ['Abchasisch', 'Abkhaz'],
  Afar: ['Afar', 'Afar'],
  Afrikaans: ['Afrikaans', 'Afrikaans'],
  Akan: ['Akan', 'Akan'],
  Albanisch: ['Albanisch', 'Albanian'],
  Amharisch: ['Amharisch', 'Amharic'],
  Arabisch: ['Arabisch', 'Arabic'],
  Aragonesisch: ['Aragonesisch', 'Aragonese'],
  Armenisch: ['Armenisch', 'Armenian'],
  Assamesisch: ['Assamesisch', 'Assamese'],
  Avarisch: ['Avarisch', 'Avaric'],
  Avestan: ['Avestan', 'Avestan'],
  Aymara: ['Aymara', 'Aymara'],
  Aserbaidschanisch: ['Aserbaidschanisch', 'Azerbaijani'],
  Bambara: ['Bambara', 'Bambara'],
  Baschkirisch: ['Baschkirisch', 'Bashkir'],
  Baskisch: ['Baskisch', 'Basque'],
  Belarussisch: ['Belarussisch', 'Belarusian'],
  Bengali: ['Bengali', 'Bengali'],
  Bhojpuri: ['Bhojpuri', 'Bhojpuri'],
  Bislama: ['Bislama', 'Bislama'],
  Bosnisch: ['Bosnisch', 'Bosnian'],
  Bretonisch: ['Bretonisch', 'Breton'],
  Bulgarisch: ['Bulgarisch', 'Bulgarian'],
  Birmanisch: ['Birmanisch', 'Burmese'],
  Katalanisch: ['Katalanisch', 'Catalan'],
  Chamorro: ['Chamorro', 'Chamorro'],
  Tschetschenisch: ['Tschetschenisch', 'Chechen'],
  Chichewa: ['Chichewa', 'Chichewa'],
  Chinesisch: ['Chinesisch', 'Chinese'],
  Tschuwaschisch: ['Tschuwaschisch', 'Chuvash'],
  Kornisch: ['Kornisch', 'Cornish'],
  Korsisch: ['Korsisch', 'Corsican'],
  Cree: ['Cree', 'Cree'],
  Kroatisch: ['Kroatisch', 'Croatian'],
  Tschechisch: ['Tschechisch', 'Czech'],
  Daenisch: ['Dänisch', 'Danish'],
  Divehi: ['Divehi', 'Divehi'],
  Niederlaendisch: ['Niederländisch', 'Dutch'],
  Dzongkha: ['Dzongkha', 'Dzongkha'],
  Englisch: ['Englisch', 'English'],
  Estnisch: ['Estnisch', 'Estonian'],
  Ewe: ['Ewe', 'Ewe'],
  Faeroeisch: ['Färöisch', 'Faroese'],
  Fidschi: ['Fidschi', 'Fijian'],
  Finnisch: ['Finnisch', 'Finnish'],
  Franzoesisch: ['Französisch', 'French'],
  Fula: ['Fula', 'Fula'],
  Schottisch_Gaelisch: ['Schottisch Gälisch', 'Scottish Gaelic'],
  Galizisch: ['Galizisch', 'Galician'],
  Georgisch: ['Georgisch', 'Georgian'],
  Deutsch: ['Deutsch', 'German'],
  Griechisch: ['Griechisch', 'Greek'],
  Guarani: ['Guarani', 'Guaraní'],
  Gujarati: ['Gujarati', 'Gujarati'],
  Haitianisch: ['Haitianisch', 'Haitian'],
  Hausa: ['Hausa', 'Hausa'],
  Hebraeisch: ['Hebräisch', 'Hebrew'],
  Herero: ['Herero', 'Herero'],
  Hiri_Motu: ['Hiri Motu', 'Hiri Motu'],
  Ungarisch: ['Ungarisch', 'Hungarian'],
  Indonesisch: ['Indonesisch', 'Indonesian'],
  Zwischensprache: ['Zwischensprache', 'Interlingue'],
  Irisch: ['Irisch', 'Irish'],
  Igbo: ['Igbo', 'Igbo'],
  Inupiaq: ['Inupiaq', 'Inupiaq'],
  Islaendisch: ['Isländisch', 'Icelandic'],
  Italienisch: ['Italienisch', 'Italian'],
  Japanisch: ['Japanisch', 'Japanese'],
  Javanisch: ['Javanisch', 'Javanese'],
  Kalaallisut: ['Kalaallisut', 'Kalaallisut'],
  Kannada: ['Kannada', 'Kannada'],
  Kanuri: ['Kanuri', 'Kanuri'],
  Kaschmir: ['Kaschmir', 'Kashmiri'],
  Kasachisch: ['Kasachisch', 'Kazakh'],
  Khmer: ['Khmer', 'Khmer'],
  Kikuyu: ['Kikuyu', 'Kikuyu'],
  Kirgisisch: ['Kirgisisch', 'Kyrgyz'],
  Komi: ['Komi', 'Komi'],
  Kongo: ['Kongo', 'Kongo'],
  Koreanisch: ['Koreanisch', 'Korean'],
  Kurdisch: ['Kurdisch', 'Kurdish'],
  Luxemburgisch: ['Luxemburgisch', 'Luxembourgish'],
  Limburgisch: ['Limburgisch', 'Limburgish'],
  Lingala: ['Lingala', 'Lingala'],
  Lao: ['Lao', 'Lao'],
  Litauisch: ['Litauisch', 'Lithuanian'],
  Luba_Katanga: ['Luba-Katanga', 'Luba-Katanga'],
  Lettisch: ['Lettisch', 'Latvian'],
  Manx: ['Manx', 'Manx'],
  Mazedonisch: ['Mazedonisch', 'Macedonian'],
  Madagassisch: ['Madagassisch', 'Malagasy'],
  Malaiisch: ['Malaiisch', 'Malay'],
  Malayalam: ['Malayalam', 'Malayalam'],
  Maltesisch: ['Maltesisch', 'Maltese'],
  Moori: ['Mōori', 'Moori'],
  Marshallisch: ['Marshallisch', 'Marshallese'],
  Mongolisch: ['Mongolisch', 'Mongolian'],
  Nauruisch: ['Nauruisch', 'Nauruan'],
  Navajo: ['Navajo', 'Navajo'],
  Noerdliches_Ndebele: ['Nördliches Ndebele', 'Northern Ndebele'],
  Nepali: ['Nepali', 'Nepali'],
  Norwegisch: ['Norwegisch', 'Norwegian'],
  Nuosu: ['Nuosu', 'Nuosu'],
  Suedliches_Ndebele: ['Südliches Ndebele', 'Southern Ndebele'],
  Okzitanisch: ['Okzitanisch', 'Occitan'],
  Ojibwe: ['Ojibwe', 'Ojibwe'],
  Oromo: ['Oromo', 'Oromo'],
  Orija: ['Orija', 'Oriya'],
  Ossetisch: ['Ossetisch', 'Ossetian'],
  Panjabi: ['Panjabi', 'Panjabi'],
  Persisch: ['Persisch', 'Persian'],
  Polnisch: ['Polnisch', 'Polish'],
  Paschtu: ['Paschtu', 'Pashto'],
  Portugiesisch: ['Portugiesisch', 'Portuguese'],
  Quechua: ['Quechua', 'Quechua'],
  Raetoromanisch: ['Rätoromanisch', 'Romansh'],
  Rumaenisch: ['Rumänisch', 'Romanian'],
  Russisch: ['Russisch', 'Russian'],
  Sardisch: ['Sardisch', 'Sardinian'],
  Sindhi: ['Sindhi', 'Sindhi'],
  Samoanisch: ['Samoanisch', 'Samoan'],
  Sango: ['Sango', 'Sango'],
  Serbisch: ['Serbisch', 'Serbian'],
  Shona: ['Shona', 'Shona'],
  Singhalesisch: ['Singhalesisch', 'Sinhalese'],
  Slowakisch: ['Slowakisch', 'Slovak'],
  Slowenisch: ['Slowenisch', 'Slovene'],
  Somali: ['Somali', 'Somali'],
  Suedliches_Sotho: ['Südliches Sotho', 'Southern Sotho'],
  Spanisch: ['Spanisch', 'Spanish'],
  Sundanesisch: ['Sundanesisch', 'Sundanese'],
  Suaheli: ['Suaheli', 'Swahili'],
  Schwati: ['Schwati', 'Swati'],
  Schwedisch: ['Schwedisch', 'Swedish'],
  Tamil: ['Tamil', 'Tamil'],
  Telugu: ['Telugu', 'Telugu'],
  Tadschikisch: ['Tadschikisch', 'Tajik'],
  Thailaendisch: ['Thailändisch', 'Thai'],
  Tigrinja: ['Tigrinja', 'Tigrinya'],
  Turkmenisch: ['Turkmenisch', 'Turkmen'],
  Tagalog: ['Tagalog', 'Tagalog'],
  Tswana: ['Tswana', 'Tswana'],
  Tonga: ['Tonga', 'Tonga'],
  Tuerkisch: ['Türkisch', 'Turkish'],
  Tsonga: ['Tsonga', 'Tsonga'],
  Tatarisch: ['Tatarisch', 'Tatar'],
  Tahitianisch: ['Tahitianisch', 'Tahitian'],
  Uiguren: ['Uiguren', 'Uyghur'],
  Ukrainisch: ['Ukrainisch', 'Ukrainian'],
  Usbekisch: ['Usbekisch', 'Uzbek'],
  Venda: ['Venda', 'Venda'],
  Vietnamesisch: ['Vietnamesisch', 'Vietnamese'],
  Wallonisch: ['Wallonisch', 'Walloon'],
  Walisisch: ['Walisisch', 'Welsh'],
  Wolof: ['Wolof', 'Wolof'],
  Westfriesisch: ['Westfriesisch', 'Western Frisian'],
  Xhosa: ['Xhosa', 'Xhosa'],
  Jiddisch: ['Jiddisch', 'Yiddish'],
  Yoruba: ['Yoruba', 'Yoruba'],
  Zulu: ['Zulu', 'Zulu'],
  otherLanguage: ['Sonstige', 'Other'],
};

export enum MatchingLanguage {
  Abchasisch = 'Abchasisch',
  Afar = 'Afar',
  Afrikaans = 'Afrikaans',
  Akan = 'Akan',
  Albanisch = 'Albanisch',
  Amharisch = 'Amharisch',
  Arabisch = 'Arabisch',
  Aragonesisch = 'Aragonesisch',
  Armenisch = 'Armenisch',
  Assamesisch = 'Assamesisch',
  Avarisch = 'Avarisch',
  Avestan = 'Avestan',
  Aymara = 'Aymara',
  Aserbaidschanisch = 'Aserbaidschanisch',
  Bambara = 'Bambara',
  Baschkirisch = 'Baschkirisch',
  Baskisch = 'Baskisch',
  Belarussisch = 'Belarussisch',
  Bengali = 'Bengali',
  Bhojpuri = 'Bhojpuri',
  Bislama = 'Bislama',
  Bosnisch = 'Bosnisch',
  Bretonisch = 'Bretonisch',
  Bulgarisch = 'Bulgarisch',
  Birmanisch = 'Birmanisch',
  Katalanisch = 'Katalanisch',
  Chamorro = 'Chamorro',
  Tschetschenisch = 'Tschetschenisch',
  Chichewa = 'Chichewa',
  Chinesisch = 'Chinesisch',
  Tschuwaschisch = 'Tschuwaschisch',
  Kornisch = 'Kornisch',
  Korsisch = 'Korsisch',
  Cree = 'Cree',
  Kroatisch = 'Kroatisch',
  Tschechisch = 'Tschechisch',
  Daenisch = 'Daenisch',
  Divehi = 'Divehi',
  Niederlaendisch = 'Niederlaendisch',
  Dzongkha = 'Dzongkha',
  Englisch = 'Englisch',
  Estnisch = 'Estnisch',
  Ewe = 'Ewe',
  Faeroeisch = 'Faeroeisch',
  Fidschi = 'Fidschi',
  Finnisch = 'Finnisch',
  Franzoesisch = 'Franzoesisch',
  Fula = 'Fula',
  Schottisch_Gaelisch = 'Schottisch_Gaelisch',
  Galizisch = 'Galizisch',
  Georgisch = 'Georgisch',
  Deutsch = 'Deutsch',
  Griechisch = 'Griechisch',
  Guarani = 'Guarani',
  Gujarati = 'Gujarati',
  Haitianisch = 'Haitianisch',
  Hausa = 'Hausa',
  Hebraeisch = 'Hebraeisch',
  Herero = 'Herero',
  Hiri_Motu = 'Hiri_Motu',
  Ungarisch = 'Ungarisch',
  Indonesisch = 'Indonesisch',
  Zwischensprache = 'Zwischensprache',
  Irisch = 'Irisch',
  Igbo = 'Igbo',
  Inupiaq = 'Inupiaq',
  Islaendisch = 'Islaendisch',
  Italienisch = 'Italienisch',
  Japanisch = 'Japanisch',
  Javanisch = 'Javanisch',
  Kalaallisut = 'Kalaallisut',
  Kannada = 'Kannada',
  Kanuri = 'Kanuri',
  Kaschmir = 'Kaschmir',
  Kasachisch = 'Kasachisch',
  Khmer = 'Khmer',
  Kikuyu = 'Kikuyu',
  Kirgisisch = 'Kirgisisch',
  Komi = 'Komi',
  Kongo = 'Kongo',
  Koreanisch = 'Koreanisch',
  Kurdisch = 'Kurdisch',
  Luxemburgisch = 'Luxemburgisch',
  Limburgisch = 'Limburgisch',
  Lingala = 'Lingala',
  Lao = 'Lao',
  Litauisch = 'Litauisch',
  Luba_Katanga = 'Luba_Katanga',
  Lettisch = 'Lettisch',
  Manx = 'Manx',
  Mazedonisch = 'Mazedonisch',
  Madagassisch = 'Madagassisch',
  Malaiisch = 'Malaiisch',
  Malayalam = 'Malayalam',
  Maltesisch = 'Maltesisch',
  Moori = 'Moori',
  Marshallisch = 'Marshallisch',
  Mongolisch = 'Mongolisch',
  Nauruisch = 'Nauruisch',
  Navajo = 'Navajo',
  Noerdliches_Ndebele = 'Noerdliches_Ndebele',
  Nepali = 'Nepali',
  Norwegisch = 'Norwegisch',
  Nuosu = 'Nuosu',
  Suedliches_Ndebele = 'Suedliches_Ndebele',
  Okzitanisch = 'Okzitanisch',
  Ojibwe = 'Ojibwe',
  Oromo = 'Oromo',
  Orija = 'Orija',
  Ossetisch = 'Ossetisch',
  Panjabi = 'Panjabi',
  Persisch = 'Persisch',
  Polnisch = 'Polnisch',
  Paschtu = 'Paschtu',
  Portugiesisch = 'Portugiesisch',
  Quechua = 'Quechua',
  Raetoromanisch = 'Raetoromanisch',
  Rumaenisch = 'Rumaenisch',
  Russisch = 'Russisch',
  Sardisch = 'Sardisch',
  Sindhi = 'Sindhi',
  Samoanisch = 'Samoanisch',
  Sango = 'Sango',
  Serbisch = 'Serbisch',
  Shona = 'Shona',
  Singhalesisch = 'Singhalesisch',
  Slowakisch = 'Slowakisch',
  Slowenisch = 'Slowenisch',
  Somali = 'Somali',
  Suedliches_Sotho = 'Suedliches_Sotho',
  Spanisch = 'Spanisch',
  Sundanesisch = 'Sundanesisch',
  Suaheli = 'Suaheli',
  Schwati = 'Schwati',
  Schwedisch = 'Schwedisch',
  Tamil = 'Tamil',
  Telugu = 'Telugu',
  Tadschikisch = 'Tadschikisch',
  Thailaendisch = 'Thailaendisch',
  Tigrinja = 'Tigrinja',
  Turkmenisch = 'Turkmenisch',
  Tagalog = 'Tagalog',
  Tswana = 'Tswana',
  Tonga = 'Tonga',
  Tuerkisch = 'Tuerkisch',
  Tsonga = 'Tsonga',
  Tatarisch = 'Tatarisch',
  Tahitianisch = 'Tahitianisch',
  Uiguren = 'Uiguren',
  Ukrainisch = 'Ukrainisch',
  Usbekisch = 'Usbekisch',
  Venda = 'Venda',
  Vietnamesisch = 'Vietnamesisch',
  Wallonisch = 'Wallonisch',
  Walisisch = 'Walisisch',
  Wolof = 'Wolof',
  Westfriesisch = 'Westfriesisch',
  Xhosa = 'Xhosa',
  Jiddisch = 'Jiddisch',
  Yoruba = 'Yoruba',
  Zulu = 'Zulu',
  otherLanguage = 'otherLanguage',
}

//   new EnumAttributeDefinition({
//     type: 'enum',
//     key: 'faculty',
//     gqlType: 'enum',
//     translations: [
//       new LanguageTranslationPair({ language: Language.GERMAN, translation: 'Fachbereich Hochschule Fulda' }),
//       new LanguageTranslationPair({ language: Language.ENGLISH, translation: 'Department Hochschule Fulda' }),
//     ],
//     label: 'Fachbereich Hochschule Fulda',
//     options: [
//       ['Angewandte Informatik', 'Applied Computer Science'],
//       ['Elektrotechnik und Informationstechnik', 'Electrical Engineering and Information Technology'],
//       ['Gesundheitswissenschaften', 'Health Sciences'],
//       ['Lebensmitteltechnologie', 'Food Technology'],
//       ['Oecotrophologie', 'Nutritional, Food and Consumer Sciences'],
//       ['Sozial- und Kulturwissenschaften', 'Social and Cultural Sciences'],
//       ['Sozialwesen', 'Social Work'],
//       ['Wirtschaft', 'Business'],
//     ].map((dep, i) =>
//       makeEnumOption(`FB${('00' + i).slice(-2)}`, [
//         `FB${('00' + i).slice(-2)} ${dep[0]}`,
//         `DEPT${('00' + i).slice(-2)} ${dep[1]}`,
//       ]),
//     ),
//   }),
// ];

// TODO we had these back in the day, do we not need them anymore?

const COUNTRIES = {
  Afghanistan: ['Afghanistan', 'Afghanistan'],
  Ägypten: ['Ägypten', 'Egypt'],
  Albanien: ['Albanien', 'Albania'],
  Algerien: ['Algerien', 'Algeria'],
  Andorra: ['Andorra', 'Andorra'],
  Angola: ['Angola', 'Angola'],
  'Antigua und Barbuda': ['Antigua und Barbuda', 'Antigua and Barbuda'],
  Äquatorialguinea: ['Äquatorialguinea', 'Equatorial guinea'],
  Argentinien: ['Argentinien', 'Argentina'],
  Armenien: ['Armenien', 'Armenia'],
  Aserbaidschan: ['Aserbaidschan', 'Azerbaijan'],
  Äthiopien: ['Äthiopien', 'Ethiopia'],
  Australien: ['Australien', 'Australia'],
  Bahamas: ['Bahamas', 'Bahamas'],
  Bahrain: ['Bahrain', 'Bahrain'],
  Bangladesch: ['Bangladesch', 'Bangladesh'],
  Barbados: ['Barbados', 'Barbados'],
  Belarus: ['Belarus', 'Belarus'],
  Belgien: ['Belgien', 'Belgium'],
  Belize: ['Belize', 'Belize'],
  Benin: ['Benin', 'Benin'],
  Bhutan: ['Bhutan', 'Bhutan'],
  Bolivien: ['Bolivien', 'Bolivia'],
  'Bosnien und Herzegowina': ['Bosnien und Herzegowina', 'Bosnia and Herzegovina'],
  Botsuana: ['Botsuana', 'Botsuana'],
  Brasilien: ['Brasilien', 'Brazil'],
  'Brunei Darussalam': ['Brunei Darussalam', 'Brunei Darussalam'],
  Bulgarien: ['Bulgarien', 'Bulgaria'],
  'Burkina Faso': ['Burkina Faso', 'Burkina Faso'],
  Burundi: ['Burundi', 'Burundi'],
  'Cabo Verde': ['Cabo Verde', 'Cabo Verde'],
  Chile: ['Chile', 'Chile'],
  China: ['China', 'China'],
  Cookinseln: ['Cookinseln', 'Cook islands'],
  'Costa Rica': ['Costa Rica', 'Costa Rica'],
  Dänemark: ['Dänemark', 'Denmark'],
  Deutschland: ['Deutschland', 'Germany'],
  Dominica: ['Dominica', 'Dominica'],
  'Dominikanische Republik': ['Dominikanische Republik', 'Dominican Republic'],
  Dschibuti: ['Dschibuti', 'Jibuti'],
  Ecuador: ['Ecuador', 'Ecuador'],
  'El Salvador': ['El Salvador', 'El Salvador'],
  Eritrea: ['Eritrea', 'Eritrea'],
  Estland: ['Estland', 'Estonia'],
  Fidschi: ['Fidschi', 'Fiji'],
  Finnland: ['Finnland', 'Finland'],
  Frankreich: ['Frankreich', 'France'],
  Gabun: ['Gabun', 'Gab'],
  Gambia: ['Gambia', 'Gambia'],
  Georgien: ['Georgien', 'Georgia'],
  Ghana: ['Ghana', 'Ghana'],
  Grenada: ['Grenada', 'Grenada'],
  Griechenland: ['Griechenland', 'Greece'],
  Großbritannien: ['Großbritannien', 'Great Britain'],
  Guatemala: ['Guatemala', 'Guatemala'],
  Guinea: ['Guinea', 'Guinea'],
  'Guinea-Bissau': ['Guinea-Bissau', 'Guinea-Bissau'],
  Guyana: ['Guyana', 'Guyana'],
  Haiti: ['Haiti', 'Haiti'],
  Honduras: ['Honduras', 'Honduras'],
  Indien: ['Indien', 'India'],
  Indonesien: ['Indonesien', 'Indonesia'],
  Irak: ['Irak', 'Iraq'],
  Iran: ['Iran', 'Iran'],
  Irland: ['Irland', 'Ireland'],
  Island: ['Island', 'Iceland'],
  Israel: ['Israel', 'Israel'],
  Italien: ['Italien', 'Italy'],
  Jamaika: ['Jamaika', 'Jamaica'],
  Japan: ['Japan', 'Japan'],
  Jemen: ['Jemen', 'Yemen'],
  Jordanien: ['Jordanien', 'Jordan'],
  Kambodscha: ['Kambodscha', 'Cambodia'],
  Kamerun: ['Kamerun', 'Cameroon'],
  Kanada: ['Kanada', 'Canada'],
  Kasachstan: ['Kasachstan', 'Kazakhstan'],
  Katar: ['Katar', 'Qatar'],
  Kenia: ['Kenia', 'Kenya'],
  Kirgisistan: ['Kirgisistan', 'Kyrgyzstan'],
  Kiribati: ['Kiribati', 'Kiribati'],
  Kolumbien: ['Kolumbien', 'Colombia'],
  Komoren: ['Komoren', 'Comor'],
  Kongo: ['Kongo', 'Congo'],
  'Kongo, Demokratische Republik': ['Kongo, Demokratische Republik', 'Congo, Democratic Republic'],
  'Korea, Nord': ['Korea, Nord', 'Korea, North'],
  'Korea, Süd': ['Korea, Süd', 'Korea, South'],
  Kosovo: ['Kosovo', 'Kosovo'],
  Kroatien: ['Kroatien', 'Croatia'],
  Kuba: ['Kuba', 'Cuba'],
  Kuwait: ['Kuwait', 'Kuwait'],
  Laos: ['Laos', 'Laos'],
  Lesotho: ['Lesotho', 'Lesotho'],
  Lettland: ['Lettland', 'Latvia'],
  Libanon: ['Libanon', 'Lebanon'],
  Liberia: ['Liberia', 'Liberia'],
  Libyen: ['Libyen', 'Libya'],
  Liechtenstein: ['Liechtenstein', 'Liechtenstein'],
  Litauen: ['Litauen', 'Lithuania'],
  Luxemburg: ['Luxemburg', 'Luxembourg'],
  Madagaskar: ['Madagaskar', 'Madagascar'],
  Malawi: ['Malawi', 'Malawi'],
  Malaysia: ['Malaysia', 'Malaysia'],
  Malediven: ['Malediven', 'Maldives'],
  Mali: ['Mali', 'Mali'],
  Malta: ['Malta', 'Malta'],
  Marokko: ['Marokko', 'Morocco'],
  Marshallinseln: ['Marshallinseln', 'Marshall Islands'],
  Mauretanien: ['Mauretanien', 'Mauritania'],
  Mauritius: ['Mauritius', 'Mauritius'],
  Mexiko: ['Mexiko', 'Mexico'],
  Mikronesien: ['Mikronesien', 'Micronesia'],
  Moldau: ['Moldau', 'Vltava'],
  Monaco: ['Monaco', 'Monaco'],
  Mongolei: ['Mongolei', 'Mongolia'],
  Montenegro: ['Montenegro', 'Montenegro'],
  Mosambik: ['Mosambik', 'Mozambique'],
  Myanmar: ['Myanmar', 'Myanmar'],
  Namibia: ['Namibia', 'Namibia'],
  Nauru: ['Nauru', 'Nauru'],
  Nepal: ['Nepal', 'Nepal'],
  Neuseeland: ['Neuseeland', 'New Zealand'],
  Nicaragua: ['Nicaragua', 'Nicaragua'],
  Niederlande: ['Niederlande', 'Netherlands'],
  Niger: ['Niger', 'Niger'],
  Nigeria: ['Nigeria', 'Nigeria'],
  Nordmazedonien: ['Nordmazedonien', 'Northern Macedonia'],
  Norwegen: ['Norwegen', 'Norway'],
  Oman: ['Oman', 'Oman'],
  Österreich: ['Österreich', 'Austria'],
  Pakistan: ['Pakistan', 'Pakistan'],
  Palästina: ['Palästina', 'Palestine'],
  Palau: ['Palau', 'Palau'],
  Panama: ['Panama', 'Panama'],
  'Papua-Neuguinea': ['Papua-Neuguinea', 'Papua New Guinea'],
  Paraguay: ['Paraguay', 'Paraguay'],
  Peru: ['Peru', 'Peru'],
  Philippinen: ['Philippinen', 'Philippines'],
  Polen: ['Polen', 'Poland'],
  Portugal: ['Portugal', 'Portugal'],
  Ruanda: ['Ruanda', 'Rwanda'],
  Rumänien: ['Rumänien', 'Romania'],
  Russland: ['Russland', 'Russia'],
  Salomonen: ['Salomonen', 'Salomons'],
  Sambia: ['Sambia', 'Zambia'],
  Samoa: ['Samoa', 'Samoa'],
  'San Marino': ['San Marino', 'San Marino'],
  'São Tomé und Príncipe': ['São Tomé und Príncipe', 'São Tomé and Príncipe'],
  'Saudi-Arabien': ['Saudi-Arabien', 'Saudi Arabia'],
  Schweden: ['Schweden', 'Sweden'],
  Schweiz: ['Schweiz', 'Switzerland'],
  Senegal: ['Senegal', 'Senegal'],
  Serbien: ['Serbien', 'Serbia'],
  Seychellen: ['Seychellen', 'Seychelles'],
  'Sierra Leone': ['Sierra Leone', 'Sierra Leone'],
  Simbabwe: ['Simbabwe', 'Zimbabwe'],
  Singapur: ['Singapur', 'Singapore'],
  Slowakei: ['Slowakei', 'Slovakia'],
  Slowenien: ['Slowenien', 'Slovenia'],
  Somalia: ['Somalia', 'Somalia'],
  Spanien: ['Spanien', 'Spain'],
  'Sri Lanka': ['Sri Lanka', 'Sri Lanka'],
  'St. Kitts und Nevis': ['St. Kitts und Nevis', 'St. Kitts and Nevis'],
  'St. Lucia': ['St. Lucia', 'St. Lucia'],
  'St. Vincent und die Grenadinen': ['St. Vincent und die Grenadinen', 'St. Vincent and the Grenadines'],
  Südafrika: ['Südafrika', 'South Africa'],
  Sudan: ['Sudan', 'Sudan'],
  Südsudan: ['Südsudan', 'South Sudan'],
  Suriname: ['Suriname', 'Suriname'],
  Syrien: ['Syrien', 'Syria'],
  Tadschikistan: ['Tadschikistan', 'Tajikistan'],
  Taiwan: ['Taiwan', 'Taiwan'],
  Tansania: ['Tansania', 'Tanzania'],
  Thailand: ['Thailand', 'Thailand'],
  'Timor-Leste': ['Timor-Leste', 'Timor-Leste'],
  Togo: ['Togo', 'Toogo'],
  Tonga: ['Tonga', 'Tonga'],
  'Trinidad und Tobago': ['Trinidad und Tobago', 'Trinidad and Tobago'],
  Tschad: ['Tschad', 'Chad'],
  'Tschechische Republik': ['Tschechische Republik', 'Czech Republic'],
  Tunesien: ['Tunesien', 'Tunisia'],
  Türkei: ['Türkei', 'Turkey'],
  Turkmenistan: ['Turkmenistan', 'Turkmenistan'],
  Tuvalu: ['Tuvalu', 'Tuvalu'],
  Uganda: ['Uganda', 'Uganda'],
  Ukraine: ['Ukraine', 'Ukraine'],
  Ungarn: ['Ungarn', 'Hungary'],
  Uruguay: ['Uruguay', 'Uruguay'],
  Usbekistan: ['Usbekistan', 'Uzbekistan'],
  Vanuatu: ['Vanuatu', 'Vanuatu'],
  Vatikanstadt: ['Vatikanstadt', 'Vatican city'],
  Venezuela: ['Venezuela', 'Venezuela'],
  'Vereinigte Arabische Emirate': ['Vereinigte Arabische Emirate', 'United Arab Emirates'],
  'Vereinigte Staaten von Amerika': ['Vereinigte Staaten von Amerika', 'United States of America'],
  Vietnam: ['Vietnam', 'Vietnam'],
  'Zentralafrikanische Republik': ['Zentralafrikanische Republik', 'Central African Republic'],
  Zypern: ['Zypern', 'Cyprus'],
  otherCountry: ['Sonstiges', 'Other'],
};
